import { render } from "./StoreShop.vue?vue&type=template&id=28f5afc4&scoped=true"
import script from "./StoreShop.vue?vue&type=script&lang=js"
export * from "./StoreShop.vue?vue&type=script&lang=js"

import "./StoreShop.vue?vue&type=style&index=0&id=28f5afc4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-28f5afc4"

export default script